class WishlistEngine {
    constructor() {
        this.options = {
            wishlistContainer: '.wishlist-container',
            priceElement: '.money',
            currencySign: '€',
        };

        this.removeCurrencySign();
    }

    removeCurrencySign() {
        const observer = new MutationObserver(() => {
            const wishlistContainer = document.querySelector(this.options.wishlistContainer);

            if (wishlistContainer) {
                let wishlistContainer = document.querySelector(this.options.wishlistContainer);
                let prices = wishlistContainer.querySelectorAll(this.options.priceElement);

                prices.forEach(price => {
                    let priceWithoutEuro = price.innerText.replace(this.options.currencySign, '');
                    price.innerText = priceWithoutEuro;
                });

                observer.disconnect();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }
}

document.addEventListener('DOMContentLoaded', () => new WishlistEngine());
